import { Injectable } from '@angular/core'
import { BaseConfigService } from '@engineering11/config-web'
import { AppConfig } from '../config'

@Injectable({ providedIn: 'root' })
export class ConfigService extends BaseConfigService<AppConfig> {}
